import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { parse } from 'query-string';
import { useMemo, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getFormValues, destroy } from 'redux-form';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { OFFER_STATUS_SELECTION } from '../../../../define/consts/rfp';
import { toDotArray } from '../../../../helpers/common/ArrayHelper';
import { propArrayShape, propShape, } from '../../../../helpers/custom-prop-types';
import { formValidateScroll } from '../../../../helpers/form';
import { compose } from '../../../../helpers/recompose';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import RfpPageTitle from '../../../Ui/Rfp/RfpPageTitle';
import ClientRfpHoc from '../Hoc/ClientRfpHoc';
import InterviewInputForm from './Parts/InterviewInput/InterviewInputForm';
import RfpOneSkeleton from './RfpOneSkeleton';
const RfpOneInterviewInput = (props) => {
    const { offers, rfp } = props;
    const { id, name } = rfp;
    const title = '面談日程を決める';
    const formName = `InterviewInputForm_${id}`;
    const dispatch = useDispatch();
    const history = useNavigate();
    const formValues = useSelector((state) => getFormValues(formName)(state));
    const pans = useMemo(() => [
        {
            link: '/mypage/project',
            text: 'マイページ',
        },
        {
            link: `/project/client/${id}/interview/view`,
            text: name,
        },
        {
            text: '面談日程を決める',
        },
    ], [id, name]);
    const { search } = useLocation();
    const initialValues = useMemo(() => {
        if (formValues) {
            return formValues;
        }
        const queryObject = parse(search);
        const idList = (queryObject.id || '').split(',');
        return {
            interviewCandidates: [{}],
            viewRequestId: offers.filter((v) => {
                const { offer: { status }, } = v;
                return (idList.includes(v.id.toString()) &&
                    status === OFFER_STATUS_SELECTION.value);
            }),
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    const onSubmit = useCallback(() => {
        history.push(`/project/client/${id}/interview/confirm${search}`);
    }, [history, id, search]);
    const onSubmitFail = useCallback((errors) => {
        const dots = Object.keys(toDotArray(errors || {}, '', {}, true));
        formValidateScroll(dots[0], { offset: -(window.innerHeight * 0.25) });
    }, []);
    useEffect(() => () => {
        if (window.location.pathname !== `/project/client/${id}/interview/confirm`) {
            dispatch(destroy(formName));
        }
    }, [id, formName, dispatch]);
    if (initialValues.viewRequestId.length === 0) {
        return _jsx(CustomRedirect, { to: `/project/client/${id}/interview/view` });
    }
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container is_interview_input' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${name} ${title}｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(RfpPageTitle, { text: name }), _jsx("div", Object.assign({ className: 'rfp_container' }, { children: _jsx("div", Object.assign({ className: 'rfp_content' }, { children: _jsxs("div", Object.assign({ className: 'rfp_content_main' }, { children: [_jsx("div", Object.assign({ className: 'rfp-card is-rfp' }, { children: _jsx("div", Object.assign({ className: 'rfp-card-head align-center' }, { children: _jsx("span", { children: title }) })) })), _jsx("div", Object.assign({ className: 'rfp-card-body' }, { children: _jsx(InterviewInputForm, { form: formName, id: id, initialValues: initialValues, onSubmit: onSubmit, onSubmitFail: onSubmitFail, viewRequests: offers }) }))] })) })) }))] })));
};
RfpOneInterviewInput.propTypes = {
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreClient: false,
    isPreview: true,
}), ClientRfpHoc({
    redirectCallback: ({ offers, rfp }) => {
        const isEnable = offers.length > 0;
        return !isEnable && `/project/client/${rfp.id}`;
    },
}, RfpOneSkeleton));
export default enhance(RfpOneInterviewInput);
